import common from '../common'

export default {
    queryBusDataOrg(params) {
      return common.get('/rocheManage/bus/busDataOrg/queryBusDataOrg', params);
    },
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/index.js